<template>
	<div class="s-home">
		<template
			v-for="(selected_component, index) in $root.selected_components"
		>
			<component
				:is="'section-' + selected_component.name"
				:section="selected_component"
				:key="'component' + selected_component.id"
				:id="selected_component.name + '-' + selected_component.id"
				class="s-section"
				@hook:mounted="create_observer(selected_component)"
			/>
			<span
				class="d-block"
				:key="`ad_${index}`"
				v-if="
					index % 3 === 0 &&
						index != 0 &&
						index + 1 != $root.selected_components.length
				"
			>
				<element-ad name="signingday-repeated-1"
			/></span>
		</template>
	</div>
</template>

<script>
// @ is an alias to /src
import IntersectionObserver from 'intersection-observer-polyfill';
import SectionCustom from '@/components/sections/SectionCustom.vue';
import SectionStories from '@/components/sections/SectionStories.vue';
import SectionHero from '@/components/sections/SectionHero.vue';
import SectionGalleries from '@/components/sections/SectionGalleries.vue';
import SectionContentstream from '@/components/sections/SectionContentStream.vue';
import SectionSocial from '@/components/sections/SectionSocial.vue';
import SectionVideos from '@/components/sections/SectionVideos.vue';
import SectionRoster from '@/components/sections/SectionRoster.vue';
import SectionPlayers from '@/components/sections/SectionPlayers.vue';
import SectionPodcasts from '@/components/sections/SectionPodcasts.vue';
import SectionSchedule from '@/components/sections/SectionSchedule.vue';

export default {
	name: 'Home',
	data: () => ({}),
	components: {
		SectionCustom,
		SectionStories,
		SectionHero,
		SectionGalleries,
		SectionContentstream,
		SectionSocial,
		SectionVideos,
		SectionRoster,
		SectionPodcasts,
		SectionPlayers,
		SectionSchedule,
	},
	methods: {
		create_observer(selected_component) {
			if (selected_component.menuInclude) {
				this.$nextTick(() => {
					const target = document.getElementById(
						selected_component.name + '-' + selected_component.id,
					);

					const observer = new IntersectionObserver(
						el => {
							if (el[0].isIntersecting) {
								this.$emit('change-section', el[0].target.id);
							}
						},
						{
							rootMargin: '-49% 0px -50% 0px',
							threshold: 0,
						},
					);

					observer.observe(target);
				});
			}
		},
	},
};
</script>

<style scoped lang="scss">
.s-home {
	min-height: 100vh;
}
</style>
